import { render, staticRenderFns } from "./GenericPDFReader.vue?vue&type=template&id=207fe266&"
import script from "./GenericPDFReader.vue?vue&type=script&lang=js&"
export * from "./GenericPDFReader.vue?vue&type=script&lang=js&"
import style0 from "./GenericPDFReader.vue?vue&type=style&index=0&id=207fe266&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports